import { generateID } from './PanelTemplatesTheme/helpers';
import { WIDGET_LABEL_SIZE } from '../../components/Widget/WidgetLabel/constants';
import { Panel } from '../../models/Panel/Panel';

export var TemplateEditorial2: Panel = {
    id: 'editorial-2',
    name: 'Header / Subheader',
    description: '',
    tags: ['Editorial', 'text', 'landscape', 'portrait', 'interstitial'],
    widget: {
        id: generateID(),
        position: {
            width: '1920px',
            height: '1080px',
            top: '0',
            left: '0',
        },
        classes: 'template_custom',
        label: {
            titleText: 'Panel header',
            enabled: false,
            size: WIDGET_LABEL_SIZE.primary,
        },
        children: [
            {
                type: 'customContentRichText',
                name: 'Rich Text',
                id: generateID(),
                position: {
                    width: '80%',
                    height: '30%',
                    top: '20%',
                    left: '10%',
                },
                label: {
                    titleText: 'Widget Header',
                    enabled: false,
                    size: WIDGET_LABEL_SIZE.primary,
                },
                options: {
                    player: {
                        playing: false,
                        duration: 15,
                    },
                    contentRichText: {
                        entityMap: {},
                        blocks: [
                            {
                                key: 'ag6qs',
                                text: 'Main Header',
                                type: 'unstyled',
                                depth: 0,
                                inlineStyleRanges: [
                                    {
                                        offset: 0,
                                        length: 11,
                                        style: 'BOLD',
                                    },
                                    {
                                        offset: 0,
                                        length: 11,
                                        style: 'CUSTOM_FONT_SIZE_20' as any,
                                    },
                                ],
                                entityRanges: [],
                                data: {},
                            },
                        ],
                    },
                    contentPadding: 5,
                    contentTextAlign: 'center',
                    verticalAlign: 'bottom',
                },
            },
            {
                type: 'customContentRichText',
                name: 'Rich Text',
                id: generateID(),
                position: {
                    width: '80%',
                    height: '30%',
                    top: '50%',
                    left: '10%',
                },
                label: {
                    titleText: 'Widget Header',
                    enabled: false,
                    size: WIDGET_LABEL_SIZE.primary,
                },
                options: {
                    player: {
                        playing: false,
                        duration: 15,
                    },
                    contentRichText: {
                        entityMap: {},
                        blocks: [
                            {
                                key: '123',
                                text: 'Subheader',
                                type: 'unstyled',
                                depth: 0,
                                inlineStyleRanges: [
                                    {
                                        offset: 0,
                                        length: 9,
                                        style: 'CUSTOM_FONT_SIZE_18' as any,
                                    },
                                ],
                                entityRanges: [],
                                data: {},
                            },
                        ],
                    },
                    contentPadding: 5,
                    contentTextAlign: 'center',
                    verticalAlign: 'top',
                },
            },
            {
                type: 'customContentRichText',
                name: 'Rich Text',
                id: generateID(),
                position: {
                    width: '50%',
                    height: '20%',
                    top: '696px',
                    left: '30px',
                },
                label: {
                    titleText: 'Widget Header',
                    enabled: false,
                    size: WIDGET_LABEL_SIZE.primary,
                },
                options: {
                    player: {
                        playing: false,
                        duration: 15,
                    },
                    contentRichText: {
                        entityMap: {},
                        blocks: [
                            {
                                key: 'a4kd93',
                                text: 'Client Name',
                                type: 'unstyled',
                                depth: 0,
                                inlineStyleRanges: [
                                    {
                                        offset: 0,
                                        length: 9,
                                        style: 'CUSTOM_FONT_SIZE_18' as any,
                                    },
                                ],
                                entityRanges: [],
                                data: {},
                            },
                        ],
                    },
                    contentPadding: 5,
                    contentTextAlign: 'left',
                    verticalAlign: 'bottom',
                },
            },
        ],
    },
};
